// extracted by mini-css-extract-plugin
module.exports = {"livescore_wrap":"style_livescore_wrap__RHOHr","livescore_empty":"style_livescore_empty__3iof7"};